import makeStyles from '@ui/utils/makeStyles';

export default makeStyles<
  {},
  'quickViewContainer'
>()((theme, _params, classes) => {
  const quickViewContainer = {
    display: 'none',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 10,
  } as const;

  return {
    quickViewContainer,
    cardContainer: {
      width: '100%',
      height: '100%',
      borderRadius: theme.shape.borderRadius,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontFamily: theme.gh_vars.circular,
      textDecoration: 'none !important',
      padding: theme.spacing(2),
      backgroundColor: '#FFFFFF',
      border: '1px solid #EBEBEB',
      [`&:hover .${classes.quickViewContainer}`]: {
        display: 'flex',
      },
    },
    imageContainer: {
      position: 'relative',
      width: '100%',
      height: '100%',
      minWidth: 100,
      minHeight: 120,
      marginBottom: theme.spacing(1),
      // backgroundBlendMode: 'darken' doesn't work but is part of the designs - needs a fix or permission from design to ignore
      '& img': {
        borderRadius: 5,
      },
      [theme.breakpoints.up('sm')]: {
        minWidth: 190,
        minHeight: 184,
      },
      [theme.breakpoints.up('md')]: {
        minWidth: 163,
        minHeight: 184,
      },
      [theme.breakpoints.up('lg')]: {
        minWidth: 163,
        minHeight: 248,
      },
      [theme.breakpoints.up('xl')]: {
        minWidth: 175,
        minHeight: 185,
      },
    },
    salePercent: {
      minWidth: 62,
      height: 24,
      borderRadius: 5,
      backgroundColor: '#EDC687',
      top: 16,
      right: 16,
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0 8px',
      fontFamily: theme.gh_vars.mabryMono,
      fontSize: 11,
      textDecoration: 'none',
    },
    infoContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      width: '100%',
      height: '100%',
      textDecoration: 'none',
      marginTop: theme.spacing(1.5),
      position: 'relative'
    },
    productTitle: {
      fontFamily: theme.gh_vars.circular,
      width: '100%',
      fontSize: 14,
      fontWeight: 600,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [theme.breakpoints.up('lg')]: {
        fontSize: 16,
      },
    },
    brandMaker: {
      width: '100%',
      height: 21,
      fontSize: 12,
      marginTop: theme.spacing(.5),
      marginBottom: theme.spacing(1),
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textDecoration: 'none',
      color: '#666666',
    },
    offerContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      width: '100%',
    },
    price: {
      fontSize: 11,
      fontFamily: theme.gh_vars.mabryMono,
      color: '#666666',
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginRight: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        fontSize: 12,
      },
    },
    like: {
      position: 'absolute',
      top: 0,
      right: 0,
    },
    withSavedPadding: {
      paddingLeft: 8
    },
    withSavedProductTitle: {
      width: 'calc(100% - 36px)',
      marginTop: 4
    },
  };
});
